import { IconButton, makeStyles } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { planEatApi } from '../../../planEatApi/PlanEatApi';
import { IOfficeContent, IVersionedObject } from '../../../planEatApi/PlanEatFacade';
import { OfficeCreationModal } from '../../../components/modals/OfficeCreationModal';
import { FrontendApi } from '../../../planEatApi/FrontendApi';
import { IServiceUserInfo } from '../../../datasolvr/ServicesFacade';
import { OfficeContext } from '../../../config/Context';
import { MdAddCircleOutline, MdModeEditOutline } from 'react-icons/md';
import { resetOffice } from '../../../utils/resetObjects';
import { AddItemButton } from '../../../components/ui/AddItemButton';
import { errorToast, successToast } from '../../../utils/crudToast';

const useStyles = makeStyles((theme: any) => ({
    title: {
        fontSize: '28px',
        fontWeight: 400,
        color: 'black',
    },
    addMenuItemInputContainer: {
        width: '100%',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        marginTop: 30,
        padding: 30
    },
    officeHeaders:{
        display:'grid',
        gridTemplateColumns:'repeat(3, 1fr)',
        justifyContent:'space-between',
        alignItems:'center',
        columnGap: 10,
        "& > *": {
            fontSize: '100%',
            fontWeight: 700,
            color:'#374251',
            maxWidth: "100%"
        },
    },
    officeContent:{
        display:'grid',
        gridTemplateColumns:'repeat(3, 1fr)',
        justifyContent:'space-between',
        alignItems:'center',
        paddingTop: 10,
        paddingBottom: 10,
        columnGap: 10,
        borderBottom: '1px dashed rgba(11, 37, 89, 0.2);',
        "& > *": {
            maxWidth: "100%",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden"
        },
    },
    usersHeaders:{
        display:'grid',
        gridTemplateColumns:'repeat(3, 1fr)',
        justifyContent:'space-between',
        alignItems:'center',
        columnGap: 10,
        "& > *": {
            fontSize: '100%',
            fontWeight: 700,
            color:'#374251',
            maxWidth: "100%",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden"
        }
    },
    usersContent:{
        display:'grid',
        gridTemplateColumns:'repeat(3, 1fr)',
        justifyContent:'space-between',
        alignItems:'center',
        paddingTop: 10,
        paddingBottom: 10,
        columnGap: 10,
        borderBottom: '1px dashed rgba(11, 37, 89, 0.2);',
        "& > *": {
            maxWidth: "100%",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden"
        },
    },
    flexRowSpaceBetween:{
        display:"flex",
        justifyContent:"space-between",
        alignItems:"center"
    },
    addMenuItemContainer: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        marginTop: 10,
        marginBottom: 10,
        borderRadius: 8,
        "& > *": {
            marginRight: 5
        },
    },
    addMenuIconStyle: {
        color: theme.palette.primary.main,
        height: 23
    },
    addMenuItemText: {
        color: theme.palette.primary.main,
        fontSize: '70%',
        fontWeight: 700
    },
    table: {
        maxHeight: 380,
        overflowY: "scroll"
    },
    adminList: {
        maxWidth: "100%",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
}));

export const AdminAccount: React.FC = () => {
    // Styling
    const classes = useStyles();

    // Context
    const officeContext = useContext(OfficeContext);

    // Entities
    const [applicationUsers,setApplicationUsers] = useState<IServiceUserInfo[]>([])
    const [offices, setOffices] = useState<IVersionedObject<IOfficeContent>[]>([]);
    const [selectedOffice, setSelectedOffice] = useState<IOfficeContent>();
    const [office, setOffice] = useState<IOfficeContent>({
        id: "",
        name: "",
        description: "",
        companyId: "",
        officeName: "",
        officeAddress: "",
        officeAdminIds: [],
        defaultSeatings: [],
        defaultAvailability: [],
        defaultDishesContent: [],
        officeSettings: undefined
    })

    // State
    const [officeCreationModalHidden,setOfficeCreationModalHidden] = useState(true)
    
    // Views
    const [officeRows, setOfficeRows] = useState<any[]>([]);
    const [userRows, setUserRows] = useState<any[]>([]);

    async function getDatabase(){
        await planEatApi.getOffices()
        .then((response) => {
            const sortedOffices = response.data.sort((a,b) => a.content.officeName.localeCompare(b.content.officeName))
            setOffices(sortedOffices)
        })
    }

    useEffect(() => {
        getDatabase()
        getAdminUsers()
    },[officeContext])

    useEffect(() => {
        displayOffices();
    }, [offices, selectedOffice]);

    useEffect(() => {
        displayUsers();
    }, [applicationUsers]);

    useEffect(() => {
        if(officeCreationModalHidden=== false){
            setSelectedOffice(resetOffice)
        }
    }, [officeCreationModalHidden]);

    function getAdminUsers() {
        if(officeContext?.office){
            FrontendApi.getAdminUsers(officeContext.office.content.id)
            .then((response) => {
                const sortedUsers = response.sort((a,b) => a.content.name.localeCompare(b.content.name))
                setApplicationUsers(sortedUsers)
            })
            .catch((e) => {
                console.log(e)
            })
        }
    }

    function displayOffices() {
        let tmpDisplay: any[] = []
        offices.forEach((office) => {
            tmpDisplay.push(
                <div className={classes.officeContent} key={office.content.id}>
                    <div>
                        {office.content.officeName}
                    </div>
                    <div>
                        {office.content.officeAddress}
                    </div>
                    <div className={classes.flexRowSpaceBetween}> 
                        <div className={classes.adminList}>
                            {office.content.officeAdminIds.toString()}
                        </div>
                        <IconButton  onClick={() => {setOfficeCreationModalHidden(false);setOffice(office.content)}}>
                            <MdModeEditOutline/>
                        </IconButton>
                    </div>
                </div>
            )
        })
        setOfficeRows(tmpDisplay);
    }

    function displayUsers() {
        let tmpDisplay: any[] = []
        applicationUsers.forEach((applicationUser) => {
            tmpDisplay.push(
                <div className={classes.usersContent} key={applicationUser.content.id}>
                    <div>
                        {applicationUser.content.name}
                    </div>
                    <div>
                        {applicationUser.content.id}
                    </div>
                    <div className={classes.flexRowSpaceBetween}> 
                        <div>
                            Admin
                        </div>
                        <IconButton >
                            <MdModeEditOutline/>
                        </IconButton>
                    </div>
                </div>
            )
        })
        setUserRows(tmpDisplay);
    }

    function postOffice(){
        if(officeContext?.office){
            office.companyId = officeContext?.office?.content.companyId
            planEatApi.postOffice(office)
            .then(response => {
                successToast("Office",office.id !== "" ? office.id : undefined)
                setOfficeCreationModalHidden(true)
                setOffice(resetOffice)
                getDatabase()
            })
            .catch(e => {
                errorToast("Office",office.id !== "" ? office.id : undefined)
            })
        }
    }

    return (
        <div>
            <div className={classes.addMenuItemInputContainer}>
                <div style={{marginBottom:50}}>
                    <div>
                        <div className={classes.title} style={{marginBottom:10}}>Offices</div>
                        <div>
                            <div className={classes.officeHeaders}>
                                <div>
                                    Office name
                                </div>
                                <div>
                                    Office Adress
                                </div>
                                <div>
                                    Office admins
                                </div>
                            </div>
                            <div className={classes.table}>
                                {officeRows}
                            </div>
                            <AddItemButton title='Add Office'  onClick={() => {setOfficeCreationModalHidden(false)}}/>
                        </div>

                    </div>
                    <div>
                        <OfficeCreationModal 
                            officeCreationModalHidden={officeCreationModalHidden}
                            setOfficeCreationModalHidden={setOfficeCreationModalHidden}
                            office={office}
                            setOffice={setOffice}
                            postOffice={postOffice}
                        />
                    </div>
                </div>
                <div>
                <div style={{marginBottom:50}}>
                    <div className={classes.title} style={{marginBottom:10}}>Admin users</div>
                        <div>
                            <div className={classes.usersHeaders}>
                                <div>
                                    Admin name
                                </div>
                                <div>
                                    Admin Email
                                </div>
                                <div>
                                    Role 
                                </div>
                            </div>
                            <div className={classes.table}>
                                {userRows}
                            </div>
                            
                        </div>

                    </div>
                    <div>
                        <OfficeCreationModal 
                            officeCreationModalHidden={officeCreationModalHidden}
                            setOfficeCreationModalHidden={setOfficeCreationModalHidden}
                            office={office}
                            setOffice={setOffice}
                            postOffice={postOffice}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}